import { CountdownTimer } from '../../CountdownTimer';
import { IKeyBannerProperty } from '@/interfaces/homepage';
import { useSelectedBanners } from '@/hooks/useSelectedBanners';
import { useEffect, useState } from 'react';
import { ModuleBanner } from '@/components/ModuleBanner';

export function CountdownBanner({ content, isHomepage }: Readonly<{ content: ReadonlyArray<IKeyBannerProperty>; isHomepage?: boolean }>) {
  const { selectedBanners } = useSelectedBanners(content);

  // Defer mounting the device-specific <Image> until after hydration so the static HTML never bakes in the wrong src.
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!selectedBanners?.length || !selectedBanners[0].Image) {
    return null;
  }

  return (
    <div data-testid="countdown-banner">
      {selectedBanners.map((banner, index) => (
        <ModuleBanner key={index} banner={banner} isHomepage={isHomepage}>
          {isMounted && banner && new Date(banner.EndDateUtc) > new Date() && <CountdownTimer content={banner} isHomepage={isHomepage} />}
        </ModuleBanner>
      ))}
    </div>
  );
}
